import React, {useState, useEffect} from 'react'
import { InputLabel, Select, MenuItem, Button, Grid, Typography, CssBaseline } from '@material-ui/core'
import { useForm, FormProvider, appendErrors } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { commerce } from '../../lib/commerce'
import FormInput from '../CheckoutForm/CustomTextField'
import useStyles from './Checkout/style'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';


const AddressForm = ({ checkoutToken, next }) => {
    const classes = useStyles();

    const [shippingCountries, setShippingCountries] = useState([])
    const [shippingCountry, setShippingCountry] = useState("")
    const [shippingSubdivisions, setShippingSubdivisions] = useState([])
    const [shippingSubdivision, setShippingSubdivision] = useState("")
    const [shippingOptions, setShippingOptions] = useState([])
    const [shippingOption, setShippingOption] = useState("")
    const methods = useForm();

    const countries = Object.entries(shippingCountries).map(([code, name]) => ({id: code, label: name}))
    const subdivisions = Object.entries(shippingSubdivisions).map(([code, name]) => ({id: code, label: name}))
    const options = shippingOptions.map((sO) => ({ id: sO.id, label: `${sO.description} - ${sO.price.formatted_with_symbol}` }))

    const fetchShippingCountries = async (checkoutTokenId) => {
        const { countries } = await commerce.services.localeListShippingCountries(checkoutTokenId)
        // [ID, MY, TH, SG, VT]
        setShippingCountries(countries)
        setShippingCountry(Object.keys(countries)[0])
    }

    const fetchShippingSubdivisions = async (countryCode) => {
        const { subdivisions } = await commerce.services.localeListSubdivisions(countryCode);
        setShippingSubdivisions(subdivisions)
        setShippingSubdivision(Object.keys(subdivisions)[0])
    }

    const fetchShippingOptions = async (checkoutTokenId, country, region=null) => {
        const options = await commerce.checkout.getShippingOptions(checkoutTokenId, {country, region})
        setShippingOptions(options)
        setShippingOption(options[0].id)
    }

    useEffect(() => {
        fetchShippingCountries(checkoutToken.id)
    }, [])

    useEffect(() => {
        if(shippingCountry) fetchShippingSubdivisions(shippingCountry)
    }, [shippingCountry])

    useEffect(() => {
        if(shippingSubdivision) fetchShippingOptions(checkoutToken.id, shippingCountry, shippingSubdivision)
    }, [shippingSubdivision])


    return (
        <>
        <CssBaseline>
           <Typography variant="h6" gutterBottom>Alamat Pengiriman</Typography>
           <FormProvider {...methods}>
               <form onSubmit={methods.handleSubmit((data) => next({ ...data, shippingCountry, shippingSubdivision, shippingOption }))}>
                    <Grid container spacing={3}>
                        <FormInput name="firstName" label="Nama Depan" />
                        <FormInput name="lastName" label="Nama Belakang" />
                        <FormInput name="address1" label="Alamat" />
                        <FormInput name="email" label="Email"/>
                        <FormInput name="city" label="Kota" />
                        <FormInput name="zip" label="Kode Pos"/>

                    <Grid item xs={12} sm={6}>
                        <InputLabel>Provinsi</InputLabel>
                        <Select value={shippingSubdivision} fullWidth onChange={(e) => setShippingSubdivision(e.target.value)}>
                           {subdivisions.map((subdivision) => (
                                <MenuItem key={subdivision.id} value={subdivision.id}>
                                    {subdivision.label}
                                </MenuItem>
                           ))}
                        </Select>
                    </Grid>
                </Grid>

                <br/>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button component={Link} to="/cart" variant="outlined"><KeyboardArrowLeftIcon/>Kembali Ke Cart</Button>
                    <Button type="submit" variant="contained" className={classes.next} >Lanjut<KeyboardArrowRightIcon/></Button>
                </div>
               </form>
           </FormProvider>
           </CssBaseline>
        </>
    )
}

export default AddressForm
